import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { vendorDocumentsApi } from "../../../api/vendorDocuments";
import { notifications } from "@mantine/notifications";

export function useVendorDocuments() {
  return useQuery({
    queryKey: ["vendor", "documents"],
    queryFn: () => vendorDocumentsApi.listDocuments(),
  });
}

export function useUploadVendorDocument() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (formData: FormData) => vendorDocumentsApi.uploadDocument(formData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vendor", "documents"] });
      queryClient.invalidateQueries({ queryKey: ["vendor-profile-ready"] });
      notifications.show({
        title: "Success",
        message: "Document uploaded successfully",
        color: "green",
      });
    },
    onError: (error: any) => {
      notifications.show({
        title: "Error",
        message: error.response?.data?.error || "Failed to upload document",
        color: "red",
      });
    },
  });
}

export function useDeleteVendorDocument() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (documentId: string) => vendorDocumentsApi.deleteDocument(documentId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vendor", "documents"] });
      queryClient.invalidateQueries({ queryKey: ["vendor-profile-ready"] });
      notifications.show({
        title: "Success",
        message: "Document deleted successfully",
        color: "green",
      });
    },
    onError: (error: any) => {
      notifications.show({
        title: "Error",
        message: error.response?.data?.error || "Failed to delete document",
        color: "red",
      });
    },
  });
}

